import Button from 'components/Button';
import MentorshipStatusChip from 'components/Chips/MentorshipStatusChip';
import List from 'components/list';
import { BoldTd, Td } from 'components/list/Td';
import { Th } from 'components/list/Th';
import {
  mentorshipStatusCanCreateInterview,
  MentorshipStatusValues,
} from 'enums/MentorshipStatus';
import React, { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { MentorshipManagementContext } from '..';

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  column-gap: 1rem;
`;

const activeColumns = {
  firstName: true,
  lastName: true,
  region: true,
  status: true,
  viewProfile: true,
};

const OngoingList: FC = () => {
  const { mentorships, error } = useContext(MentorshipManagementContext);
  return (
    <List
      columnNumber={5}
      isEmpty={mentorships?.length === 0}
      emptyText="Vous n'avez pas de mentorat en cours pour le moment"
      loading={!mentorships && !error}
      pages={1}
      page={0}
      setPage={() => {
      }}
      activeColumns={activeColumns}
    >
      <Th name="firstName">Prénom</Th>
      <Th name="lastName">Nom</Th>
      <Th name="region">Région</Th>
      <Th name="status">Statut du mentorat</Th>
      <Th name="viewProfile"></Th>
      {mentorships?.map((mentorship, idx) => {
        return (
          <React.Fragment key={idx}>
            <BoldTd name="firstName">
              <Link to={'details/' + mentorship.id + '/'}>
                {mentorship.mentee?.firstName}
              </Link>
            </BoldTd>
            <BoldTd name="lastName">
              <Link to={'details/' + mentorship.id + '/'}>
                {mentorship.mentee?.lastName}
              </Link>
            </BoldTd>
            <Td name="region">{mentorship.mentee?.region}</Td>
            <Td name="status">
              {mentorship.status && (
                <MentorshipStatusChip
                  variant="mentor"
                  status={mentorship.status}
                />
              )}
            </Td>
            <Td name="viewProfile">
              <ButtonsContainer>
                {mentorshipStatusCanCreateInterview.includes(
                  mentorship.status as MentorshipStatusValues,
                ) && (
                  <>
                    {/* Nouveau bouton : Déclarer un entretien passé */}
                    <Link to={`details/${mentorship.id}/interviews/DeclarePastInterview`}>
                      <Button color="default">Créer un compte-rendu d'entretien</Button>
                    </Link>

                    {/* Bouton existant : Nouvel entretien */}
                    <Link to={`details/${mentorship.id}/interviews/suggest`}>
                      <Button color="primary">Nouvel entretien</Button>
                    </Link>
                  </>
                )}
                <Link to={'details/' + mentorship.id + '/'}>
                  <Button variant="outlined" color="primary">
                    Voir le profil
                  </Button>
                </Link>
              </ButtonsContainer>
            </Td>
          </React.Fragment>
        );
      })}
    </List>
  );
};

export default OngoingList;
